import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { DashboardFrameService } from '../../dashboard-frame.service';

@Component({
	selector: 'dev-banner',
	standalone: true,
	templateUrl: './dev-banner.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./dev-banner.part.scss']
})

export class DevBannerPart {

	private frameService = inject(DashboardFrameService);
	public isDev = computed(()=> this.frameService.config().environmentName !== 'PROD');

}